import { useEffect } from "react";

export default function Terms() {
  useEffect(() => { document.title = "Terms, Prints & Refunds — Scott Burton Photography"; }, []);
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 pt-28 pb-24" data-testid="terms-page">
      <div className="overline-label mb-3">Legal</div>
      <h1 className="font-serif text-5xl lg:text-6xl font-light">Terms, Prints &amp; Refunds</h1>
      <p className="mt-4 text-neutral-500 text-sm">Last updated {new Date().getFullYear()}</p>

      <div className="mt-10 space-y-8 text-neutral-300 leading-relaxed text-sm">
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">Prints &amp; production</h2>
          <p>All fine-art prints are produced by Miller's Professional Imaging on professional archival media. Because each print is made to order from the exact frame you select, please review your selection, size and finish carefully before checkout.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">Shipping</h2>
          <p>Prints typically ship within 5–10 business days of order confirmation. You will receive an email update when your order enters production and again when it ships. Delivery times vary by destination and selected shipping method.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">Refunds &amp; damaged prints</h2>
          <p>Because prints are custom-made, we cannot accept returns for change of mind. If your print arrives damaged or with a production defect, contact us within 14 days with a photo and we will reprint or refund it at no cost.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">Licensing</h2>
          <p>Time-lapse and image licences grant the usage rights described at checkout (personal or commercial). Licences are non-transferable. Copyright in all images and footage remains with Scott Burton Photography at all times.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">Copyright &amp; usage</h2>
          <p>All photographs, footage and time-lapse sequences on this site are © Scott Burton Photography. They may not be copied, reproduced, or used without a purchased licence or written permission.</p>
        </section>
        <section>
          <h2 className="font-serif text-2xl font-light text-white mb-2">Questions</h2>
          <p>For anything about an order, licence or these terms, use the <a className="text-amber-glow" href="/contact">contact form</a> or call 662.801.3526.</p>
        </section>
      </div>
    </div>
  );
}
